import { Routes } from '@angular/router';
import { HomeComponent } from '../components/home/home.component';
import { CustomerDetailsComponent } from '../customers/components/customer-details/customer-details.component';
import { EditCustomerComponent } from '../components/customer/edit-customer/edit-customer.component';
import { SignInComponent } from '../components/sign-in/sign-in.component';
import { MerchantAccountActivationComponent } from '../components/merchant-account-activation/merchant-account-activation.component';
import { RegistrationComponent } from '../components/registration/registration.component';
import { EventListingComponent } from '../components/event-listing/event-listing.component';
import { WebhookLogsListComponent } from '../components/webhook-logs-list/webhook-logs-list.component';
import { EventDetailsComponent } from '../components/event-details/event-details.component';
import { MerchantProfileComponent } from '../merchant/components/merchant-profile/merchant-profile.component';
import { UserRoleComponent } from '../user-role/user-role.component';
import { EditUserComponent } from '../merchant/components/edit-user/edit-user.component';
import { AuthGuardService } from '../data/services/AuthGuard/auth-guard.service';
import { ManualInvoicePaymentComponent } from '../components/manual-invoice-payment/manual-invoice-payment.component';
// import {WebhooksComponent} from '../components/webhooks/webhooks.component';
import { CreateConnectAccountComponent } from '../components/connect/create-connect-account/create-connect-account.component';
import { AccountListComponent } from '../components/connect/account-list/account-list.component';
import { AccountSettingsComponent } from '../components/connect/account-settings/account-settings.component';
import { AccountDetailsComponent } from '../components/connect/account-details/account-details.component';
import { CollectedFeesListComponent } from '../components/connect/collected-fees-list/collected-fees-list.component';
import { CollectedFeesDetailsComponent } from '../components/connect/collected-fees-details/collected-fees-details.component';
import { ForgotPasswordComponent } from '../components/forgot-password/forgot-password.component';
import { DisputesComponent } from '../paymemtModule/components/disputes/disputes.component';
import { VampComponent } from '../vamp/vamp.component';
import { DisputeDetailsComponent } from '../paymemtModule/components/dispute-details/dispute-details.component';
import { DisputesFormComponent } from '../paymemtModule/components/disputes-form/disputes-form.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { AdminComponent } from '../components/admin/admin.component';
import { AccountBrandingComponent } from '../components/account-branding/account-branding.component';
import { StatementsComponent } from '../components/statements/statements.component';
import { MultiFactorAuthenticationComponent } from '../multi-factor-authentication/multi-factor-authentication.component';
import { ManualAchInvoicePaymentComponent } from '../components/manual-ach-invoice-payment/manual-ach-invoice-payment.component';
import {AiReportsComponent} from '../aiReports/ai-reports.component';
import {WebhookLogDetailsComponent} from '../components/webhook-log-details/webhook-log-details.component';
import {ExternalLinkGuardService} from '../data/services/ExternalLinkGuard/external-link-guard.service';
import { ExternalLinkStubComponent } from '../zenDeskModule/components/zen-desk-knowledge/external-link-stub.component';
import {PasswordResetComponent} from '../components/password-reset/password-reset.component';
import {ChangeRequestHistoryComponent} from '../components/change-request-history/change-request-history.component';

/**
 * Created by abhijeet on 30/1/18.
 */

export const appRoutes: Routes = [
  { path: '', redirectTo: '/signin', pathMatch: 'full'},
  // {path: 'admin', redirectTo: '/admin', pathMatch: 'full'},
  // { path: 'payment', pathMatch: 'full', canActivate: [AuthGuardService] },
  // routes for component in app core
  { path: 'home', component: HomeComponent, canActivate: [AuthGuardService], data: {title: 'Home'} },
  { path: 'pay/:id', component: ManualInvoicePaymentComponent, data: {title: 'Pay Invoice'} },
  { path: 'pay-ach/:id', component: ManualAchInvoicePaymentComponent, data: {title: 'Pay Invoice'}},
  { path: 'disputes/dispute-list', component: DisputesComponent, canActivate: [AuthGuardService], data: {title: 'Disputes'} },
  // Both paths point to the same standalone VampComponent so the page loads whichever the
  // (possibly cached) menu link uses. 'payment/vamp-details' is listed before the lazy 'payment'
  // route so this explicit path wins.
  { path: 'vamp-details', component: VampComponent, canActivate: [AuthGuardService], data: {title: 'VAMP Details'} },
  { path: 'payment/vamp-details', component: VampComponent, canActivate: [AuthGuardService], data: {title: 'VAMP Details'} },
  { path: 'loading..', component: LoaderComponent, canActivate: [AuthGuardService], data: {title: 'Loading'} },
  { path: 'disputes/dispute-details', component: DisputeDetailsComponent, canActivate: [AuthGuardService], data: {title: 'Dispute Details'} },
  { path: 'disputes/dispute-form', component: DisputesFormComponent, canActivate: [AuthGuardService], data: {title: 'Dispute Form'} },
  // {path: 'customer/customer-list', component: CustomerListComponent, canActivate: [AuthGuardService]},
  { path: 'signin', component: SignInComponent, data: {title: 'Sign In'} },
  { path: 'admin', component: AdminComponent, data: {title: 'Admin'} },
  { path: 'merchant/branding', component: AccountBrandingComponent, canActivate: [AuthGuardService], data: {title: 'Branding'} },
  { path: 'merchant/branding/change-request-history', component: ChangeRequestHistoryComponent, canActivate: [AuthGuardService], data: {title: 'Branding Change History'} },
  { path: 'register', component: RegistrationComponent, data: {title: 'Register'} },
  { path: 'password-reset', redirectTo: 'signin/password-reset'},
  { path: 'signin/password-reset', component: PasswordResetComponent, data: {title: 'Reset Password'} },
  { path: 'signin/forgotpassword', component: ForgotPasswordComponent, data: {title: 'Forgot Password'} },
  { path: 'statements', component: StatementsComponent, canActivate: [AuthGuardService], data: {title: 'Statements'} },
  { path: 'signin/step-verification', component: MultiFactorAuthenticationComponent, canActivate: [AuthGuardService], data: {title: 'Two-Factor Verification'}},
  {
    // pathMatch: 'full' — without it, the default 'prefix' match swallows
    // /events-and-logs/webhooks too (this route comes first and has no children to
    // consume the extra segment), so the dedicated webhooks route below never activates.
    path: 'events-and-logs',
    pathMatch: 'full',
    component: EventListingComponent,
    canActivate: [AuthGuardService],
    data: {title: 'Events & Logs'},
  },
  {
    path: 'events-and-logs/webhooks',
    component: WebhookLogsListComponent,
    canActivate: [AuthGuardService],
    data: {title: 'Webhook Calls'},
  },
  {
    path: 'event-details',
    component: EventDetailsComponent,
    canActivate: [AuthGuardService],
    data: {title: 'Event Details'},
  },
  {
    path: 'webhook-log-details',
    component: WebhookLogDetailsComponent,
    canActivate: [AuthGuardService],
    data: {title: 'Webhook Log Details'},
  },
  {
    path: 'merchant/merchant-activation',
    component: MerchantAccountActivationComponent,
    canActivate: [AuthGuardService],
    data: {title: 'Merchant Activation'},
  },
  // {
  //   path: 'merchant-split-funding',
  //   component: MerchantSplitFundingComponent,
  //   canActivate: [AuthGuardService],
  // },
  {
    path: 'merchant-update',
    component: MerchantAccountActivationComponent,
    canActivate: [AuthGuardService],
    data: {title: 'Merchant Activation'},
  },
  {
    path: 'merchant',
    loadChildren: () => import('../../app/merchant/merchant.module').then(m => m.MerchantModule),
    canActivate: [AuthGuardService],
    data: {title: 'Merchant Profile'},
  },
  {
    path: 'merchant-bridge',
    loadChildren: () => import('../../app/merchant-bridge-module/merchant-bridge-module.module').then(m => {console.log('merchant bridge',m); return m.MerchantBridgeModule}),
    canActivate: [AuthGuardService],
    data: {title: 'Payarc Bridge'},
  },
  {
    path: 'user-and-roles',
    component: UserRoleComponent,
    canActivate: [AuthGuardService],
    data: {title: 'Users & Roles'},
  },
  // routes to initialize modules
  {
    path: 'balance',
    loadChildren: () => import('../../app/balanceModule/balance.module').then(m => m.BalanceModule),
    canActivate: [AuthGuardService],
    data: {title: 'Deposits'},
  },
  {
    path: 'all-merchants',
    loadChildren: () => import('../../app/allMerchantsModule/all-merchants.module').then(m => m.AllMerchantsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'ach-rejects',
    loadChildren: () => import('../../app/achRejectModule/ach-reject.module').then(m => m.AchRejectModule),
    canActivate: [AuthGuardService],
    data: {title: 'ACH Rejects'},
  },
  {
    path: 'zendesk-tickets',
    loadChildren: () => import('../../app/zenDeskModule/zen-desk.module').then(m => m.ZenDeskModule),
    canActivate: [AuthGuardService],
    data: {title: 'Support Tickets'},
  },
  {
    path: 'zendesk-knowledge',
    component: ExternalLinkStubComponent,
    canActivate: [AuthGuardService, ExternalLinkGuardService],
    data: {title: 'Payarc Assist'},
  },
  {
    path: 'zendesk-sso',
    component: ExternalLinkStubComponent,
    canActivate: [AuthGuardService, ExternalLinkGuardService],
    data: {title: 'Payarc Assist'},
  },
  {
    path: 'payment',
    loadChildren: () => import('../../app/paymemtModule/payment/payment.module').then(m => m.PaymentModule),
    canActivate: [AuthGuardService],
    data: {title: 'Transactions'},
  },
  {
    path: 'reports',
    loadChildren: () => import('../../app/reportsModule/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuardService],
    data: {title: 'Reports'},
  },
  {
    path: 'subscription',
    loadChildren:
      () => import('../../app/subscriptionModule/subscription.module').then(m => m.SubscriptionModule),
    canActivate: [AuthGuardService],
    data: {title: 'Subscriptions'},
  },
  {
    path: 'api',
    loadChildren: () => import('../../app/apiModule/api.module').then(m => m.ApiModule),
    canActivate: [AuthGuardService],
    data: {title: 'API'},
  },
  {
    path: 'risks',
    loadChildren: () => import('../../app/risks/risk.module').then(m => m.RiskModule),
    canActivate: [AuthGuardService],
    data: {title: 'Risk Management'},
  },
  {
    path: 'customer',
    loadChildren: () => import('../../app/customers/customers.module').then(m => {console.log(m); return m.CustomersModule}),
    canActivate: [AuthGuardService],
    data: {title: 'Customers'},
  },
  // {path: 'webhooks', component: WebhooksComponent},
  { path: 'bridge/bridge-accounts', component: AccountListComponent, canActivate: [AuthGuardService], data: {title: 'Bridge Accounts'} },
  { path: 'bridge/bridge-account-details', component: AccountDetailsComponent, canActivate: [AuthGuardService], data: {title: 'Bridge Account Details'} },
  { path: 'bridge/collected-fees', component: CollectedFeesListComponent, canActivate: [AuthGuardService], data: {title: 'Collected Fees'} },
  {
    path: 'bridge/bridge-account-settings',
    component: AccountSettingsComponent, canActivate: [AuthGuardService],
    data: {title: 'Bridge Account Settings'},
  },
  {
    path: 'collected-fees/collected-fees-details',
    component: CollectedFeesDetailsComponent, canActivate: [AuthGuardService],
    data: {title: 'Collected Fees Details'},
  },
  { path: 'create-bridge-account', component: CreateConnectAccountComponent, canActivate: [AuthGuardService], data: {title: 'Create Bridge Account'} },
  { path: 'ai-reports', component: AiReportsComponent, canActivate: [AuthGuardService], data: {title: 'AI Reports'} },
  { path: '**', redirectTo: '/signin' }
];
